<div class="full-width" #map style="height: 500px"></div>
